import { Box, InputBase, Paper, styled, TextareaAutosize } from "@mui/material";

interface ChatInputContainerProps {
  isStartChat: boolean;
  isUserInputFile: boolean;
}

export const ChatInputContainer = styled(Paper, {
  shouldForwardProp: (prop) => prop !== "isStartChat",
})<ChatInputContainerProps>(({ theme, isStartChat, isUserInputFile }) => ({
  display: "flex",
  flexDirection: "column", // sorgt dafür, dass Inhalt untereinander angeordnet wird
  alignItems: "center",
  padding: theme.spacing(1.5, 2.5),
  width: "100%",
  minWidth: "95%",
  [theme.breakpoints.up("sm")]: {
    minWidth: "60vw",
    maxWidth: "80vw",
  },
  maxWidth: "70vw",
  minHeight: isUserInputFile ? 120 : 80, // flexibler als feste Höhe
  borderRadius: 16,
  backgroundColor: theme.palette.background.paper,
  boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
  ...(isStartChat
    ? {}
    : {
        position: "fixed",
        bottom: theme.spacing(3),
        left: 0,
        right: 0,
        margin: "0 auto",
        zIndex: 1300,
        justifyContent: "center",
      }),
}));

export const StyledInput = styled(InputBase)(({ theme }) => ({
  flex: 1,
  marginLeft: theme.spacing(2),
  color: theme.palette.text.primary,
  fontSize: "0.95rem",
  lineHeight: 1.5,
  padding: theme.spacing(1),
  backgroundColor: "transparent",
}));

export const StyledFileBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  marginRight: theme.spacing(1),
  position: "relative",
}));
export const StyledAutoGrowingInput = styled(TextareaAutosize)(({ theme }) => ({
  flex: 1,
  marginLeft: theme.spacing(2),
  fontFamily: theme.typography.fontFamily,
  color: theme.palette.text.primary,
  fontSize: "0.95rem",
  lineHeight: 1.5,
  padding: theme.spacing(1),
  maxHeight: 160,           // maximale Höhe z. B. 160px
  overflowY: 'auto',        // wenn zu lang -> Scrollbar
  resize: 'none',           // User kann nicht manuell vergrößern
  border: 'none',
  outline: 'none',
  backgroundColor: "transparent",
  width: '100%',
}));
export const StyledRemoveImageButton = styled("button")(({ theme }) => ({
  position: "absolute",
  top: 0,
  right: 0,
  background: theme.palette.grey[700],
  color: "#fff",
  border: "none",
  borderRadius: "50%",
  width: 20,
  height: 20,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  fontSize: 12,
  lineHeight: 1,
  padding: 0,
  zIndex: 2,
}));

export const StyledImageWrapper = styled("div")({
  position: "relative",
  width: 50,
  height: 50,
});

export const StyledFileAsImage = styled("img")(({ theme }) => ({
  width: 50,
  height: 50,
  borderRadius: 8,
  marginRight: theme.spacing(1),
  display: "block",
  "&:hover": {
    transform: "scale(1.03)",
  },
}));


export const StyledChatInputBarContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  px: 1.5,
  py: 1,
  flexDirection: "column",
  alignItems: "center",
  marginTop: "10%",
}));        